// ------------------------------------
// props 輸入需求 :
// props.p : object : { data: array }               ( residnet info )
// props.mac_alert : object : { data: array }            ( user info )
// ------------------------------------


import React from 'react'
import '../_Resident.scss'
import comm_imgs from '../../../comm_imgs';
import { useTranslation } from 'react-i18next';
import ConfigHandler from '../../../actions/ConfigHandler';

const ResidentMacAlert = (props) => {
    let mac = props.macData;
    const { t } = useTranslation();
    return (
        <div className="flex-grow-1 body-container">
            {/* <div className="body img-array"> */}
            <div className="fx-d-c w-80">
                {/* 久臥 */}
                {/* {(mac.long_stay_day)? <img className='img_crisp img_condition' src={comm_imgs['217_LONG_STAY_1']} alt=''/>:null} */}
                {(mac.long_stay_day) ? <div className='w-100 fx-d-r'><div className='fx-ccc w-60'>{t('RESIDENTS_SETTING.SENSOR.LONG_LYING_WARNING')}</div><div className='fx-ccc w-40'>{mac.long_stay_day}{t('GLOBAL.UNIT.MINUTE')}</div></div> : null}
                {/* 離床 */}
                {/* {(mac.leaving_overtime_day)? <img className='img_crisp img_condition' src={comm_imgs['218_LEAVING_OVERTIME_1']} alt=''/>:null} */}
                {(mac.leaving_overtime_day) ? <div className='w-100 fx-d-r'><div className='fx-ccc w-60'>{t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_TOO_LONG_WARNING')}</div><div className='fx-ccc w-40'>{mac.leaving_overtime_day}{t('GLOBAL.UNIT.MINUTE')}</div></div> : null}
                {/* 警告層級 */}
                {/* {(mac.alert_level_day)? <img className='img_crisp img_condition' src={comm_imgs['14_EXIT_1']} alt=''/>:null}             */}
                {(mac.alert_level_day) ? <div className='w-100 fx-d-r'><div className='fx-ccc w-60'>{t('RESIDENTS_SETTING.SENSOR.OUT_OF_BED_SENSITIVITY')}</div><div className='fx-ccc w-40'>{mac.alert_level_day}{t('GLOBAL.UNIT.STAGE')}</div></div> : null}
                {/* 呼吸 */}
                {/* {(mac.breath_low)? <img className='img_crisp img_condition' src={comm_imgs['103_RESPIRATORY']} alt=''/>:null} */}
                {
                    (mac.breath_low && ConfigHandler.isFdaClass != 2)
                        ? <div className='w-100 fx-d-r'>
                            <div className='fx-ccc w-60'>{t('RESIDENTS_SETTING.SENSOR.RESPIRATORY_LOW')}</div>
                            <div className='fx-ccc w-40'>{mac.breath_low}{t('GLOBAL.UNIT.BREATHS_PER_SECOND')}</div>
                        </div>
                        : null
                }
            </div>
        </div>
    );

}
export default ResidentMacAlert;